import type { FabricImage } from 'fabric';

// Videos only expose corner handles to prevent non-uniform stretching.
export const applyVideoControls = (obj: FabricImage): void => {
  obj.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false });
};
